export default function formatDate(dateStr) {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const date = dateStr.split('-');
  return `${monthNames[parseInt(date[1]) - 1]} ${parseInt(date[2])}, ${date[0]}`;
}